import { PLATFORMS } from 'constants/general';
import { MAC_MESSAGE_HANDLER } from 'enums';
import {
  AccessTokenRequestPayload,
  WebviewReadyPayload
} from 'interfaces/bridge.interface';
import { safeStringify } from 'utils/helpers';

type WebkitMessageHandler = { postMessage: (message: unknown) => void };

const getMacWebkitHandler = (
  handlerName: string
): WebkitMessageHandler | undefined =>
  (
    window.webkit?.messageHandlers as
      | Record<string, WebkitMessageHandler | undefined>
      | undefined
  )?.[handlerName];

export const postToMacWebkitHandler = (
  handlerName: string,
  message: unknown
): void => {
  getMacWebkitHandler(handlerName)?.postMessage(message);
};

// True when the Mac has registered the webview_ready handler, i.e. this page is inside
// a Mac WKWebView that is listening for the readiness handshake.
export const hasMacWebviewReadyHandler = (): boolean =>
  Boolean(getMacWebkitHandler(MAC_MESSAGE_HANDLER.WEBVIEW_READY));

// Posts a readiness signal to the Mac. The Mac reads message.body as an object, so the
// payload is passed through unstringified (unlike request_access_token).
export const postWebviewReadyToMac = (payload: WebviewReadyPayload): void => {
  postToMacWebkitHandler(MAC_MESSAGE_HANDLER.WEBVIEW_READY, payload);
};

export const postToReactNativeWebView = (message: string): void => {
  window.ReactNativeWebView?.postMessage(message);
};

export const postToWindowsWebView = (message: unknown): void => {
  window.chrome?.webview?.postMessage(message);
};

export const postAccessTokenRequestToNative = (
  platform: string,
  payload: AccessTokenRequestPayload
): void => {
  if (platform === PLATFORMS.MAC) {
    postToMacWebkitHandler('request_access_token', safeStringify(payload));
    return;
  }

  if (platform === PLATFORMS.WIN) {
    postToWindowsWebView(payload);
  }
};
